<template>
  <div>
    <ModalFile
        :selected-image="selectedImage"
        v-show="isModalVisible"
        @close="closeModal"
        @validate="validateModal"
    />
    <div class="form-field form-file">
      <div class="form-label" v-show="label">
        <label>{{ label }}</label>
      </div>
      <div class="form-input">
        <div class="form-input-wrapper">
          <div class="form-file-upload" v-if="uniqueId" v-bind:style="{ width: sizeW }">
            <input class="input" type="file" :id="uniqueId" @change="upload($event)">
            <div class="image" v-if="file" @click="editImage">
              <img v-if="!file.url" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" height="auto"/>
              <div>
                <img v-if="file.type == 'image'" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" v-bind:style="{ backgroundImage: 'url(' + file.preview + ')' }" height="auto"/>
                <img v-if="file.mime == 'application/pdf'" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" v-bind:style="{ backgroundImage: 'url(' + file.preview + ')' }" height="auto"/>
                <img v-if="file.mime == 'application/json'" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" v-bind:style="{ backgroundImage: 'url(/src/assets/images/file-xml.png)' }" height="auto"/>
              </div>
              <span class="icon icon-icon_picture" v-if="!file.url"></span>
              <button class="bt-remove" v-if="file" @click="remove()"><i class="icon icon-icon_close"></i></button>
            </div>
            <div class="image" v-if="file == null">
              <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" height="auto"/>
              <span class="icon icon-icon_picture"></span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {Api} from '../../Api.js'

    import ModalFile from './ModalFile.vue'
    import ScopeService from "../../modules/scope/ScopeService";

    export default {
        name: 'Upload',
        components: {ModalFile},
        props: ['value','width','label'],
        data: function () {
            return {
              selectedImage: null,
              isModalVisible: false,
              internalValue: '',
              file: '',
              uniqueId: null
          }
        },
        created: function() {
            let n = Math.floor(Math.random()*11);
            let k = Math.floor(Math.random()* 1000000);
            this.uniqueId = "file-upload-"+String.fromCharCode(n)+k;

            this.internalValue = this.value;
            this.sizeW = this.width ? this.width + "px" : "auto";
            this.get()

            //console.log("dom", document.getElementById( this.uniqueId ));
        },
        methods: {
            openModal() {
              this.isModalVisible = true
            },
            closeModal() {
              this.isModalVisible = false
            },
            validateModal() {
              this.isModalVisible = false
            },
            editImage(){
              this.selectedImage = this.file
              this.openModal();
              return false;
            },
            upload(e){
                var fileInput = document.getElementById( this.uniqueId );
                var data = new FormData();
                    data.append( 'file', fileInput.files[0] );

                Api().post('media', data).then((response) => {
                    this.internalValue = response.data[0].id
                    this.file = response.data[0]
                    this.$emit('input', this.internalValue);
                })
            },
            remove(){
                this.file = null
                this.internalValue = null
                this.$emit('input', this.internalValue);
            },
            get(){
                if( this.internalValue ){

                    Api().get('media/'+this.internalValue).then((response) => {
                        this.file = response.data
                    })

                }else{

                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.get()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/File.vue